import React from "react";

// components
import Navbar from "../../components/Navbar";
import SimpleSlider from "../../components/hero";

import Features from "../../components/features";
import AboutSection from "../../components/about";
import PracticeArea from "../../components/PracticeArea";
import ContactSection from "../../components/ContactSection";
import FooterSection from "../../components/Footer";
import saveToApm from "../../apm";
import { useEffect} from "react";

const Homepage = () => {
    useEffect(() => {
        saveToApm("Home Page (index.js)");
    }, []);

  return (
    <div>
      <Navbar />
      <SimpleSlider />
      <Features />
      <AboutSection />
      <PracticeArea />
      <ContactSection />
      <FooterSection />
    </div>
  );
};

export default Homepage;
